import { equalsNormalized, normalizeString } from 'helpers/stringNormalize';

export const PRE_DEPOSIT_PLACEHOLDER_FIRST_NAME = 'Dear';
export const PRE_DEPOSIT_PLACEHOLDER_LAST_NAME = 'Customer';

const isPlaceholderName = (value: string | null | undefined, placeholder: string): boolean =>
    equalsNormalized(value, placeholder);

export const hasRealPreDepositFirstName = (firstName?: string | null): boolean => Boolean(normalizeString(firstName));

export const hasRealPreDepositLastName = (lastName?: string | null): boolean => Boolean(normalizeString(lastName));

export const hasRealPreDepositNames = (firstName?: string | null, lastName?: string | null): boolean =>
    hasRealPreDepositFirstName(firstName) &&
    hasRealPreDepositLastName(lastName) &&
    !(
        isPlaceholderName(firstName, PRE_DEPOSIT_PLACEHOLDER_FIRST_NAME) &&
        isPlaceholderName(lastName, PRE_DEPOSIT_PLACEHOLDER_LAST_NAME)
    );
